import axios from 'axios';

// const baseUrl = 'http://localhost:3100/api/v1';
// const baseUrl = 'http://192.168.1.109:3100/api/v1';
// const baseUrl = 'http://192.168.1.4:3100/api/v1';
// const baseUrl = 'https://api-simasganteng-tuban.pohonmedia.com/api/v1';
const baseUrl = 'https://apisimasganteng.tubankab.go.id/api/v1';

export default axios.create({
  baseURL: baseUrl
});
